import { css } from 'lit';

export const style = css`
  .error-message-container {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  img {
    height: 40px;
    width: 40px;
  }

  p {
    padding: 0 0.5em;
    text-align: center;
  }
`;
